// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Fjjaz","rootOffWhite":"styles_rootOffWhite__+f0nc","main":"styles_main__yaHlf"};